export const msalConfig = {
    auth: {
        clientId: window.CADMUS_UI_MICROSOFT_CLIENT_ID,
        authority:
            `https://login.microsoftonline.com/${window.TNM_MICROSOFT_TENANT_ID}`,
        redirectUri: window.REACT_APP_UI_BASE_URL,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"],
};

export const apiRequest = {
    scopes: [`api://${window.CADMUS_API_MICROSOFT_CLIENT_ID}/user_impersonation`],
};
